// components/DashboardSkeleton.tsx

export default function DashboardSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="mb-10 h-6 w-1/4 rounded bg-neutralLight" />

      {/* Statistics Cards */}
      <div className="mb-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
        {Array.from({ length: 2 }, (_, index) => (
          <div
            key={index}
            className="rounded-xl bg-white shadow-md"
          >
            <div className="border-b border-neutralExtraLight px-5 py-6">
              <div className="h-4 w-1/3 rounded bg-neutralLight" />
            </div>
            <div className="px-5 py-9">
              <div className="h-8 w-1/2 rounded bg-neutralLight" />
            </div>
          </div>
        ))}
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-1">
        {Array.from({ length: 1 }, (_, idx) => (
          <div
            key={idx}
            className="rounded-xl bg-white p-6 shadow-md"
          >
            <div className="mb-6 h-4 w-1/3 rounded bg-neutralLight" />
            <div className="space-y-6">
              {Array.from({ length: 3 }, (_, i) => (
                <div
                  key={i}
                  className="flex justify-between border-b pb-2"
                >
                  <div className="h-4 w-1/3 rounded bg-neutralLight" />
                  <div className="h-4 w-10 rounded bg-neutralLight" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
